import { usePageTitle } from './usePageTitle';

export function PageTitle() {
  const { title } = usePageTitle();

  return title ? <h1>{title}</h1> : null;
}
